// Katalog sayfası × sektör paketleri (§5 Katalog): süzgeç + rozet verisi.
// KpiCatalogPage 600 satır sınırına yakın — durum burada; sayfa yalnız `bar` ve `tableProps` alır.
// Katalogdan seçip "Pakete ekle" 2026-11-03 ürün kararıyla kaldırıldı (Paketler ekranı tek yol).

import { useEffect, useMemo, useState } from "react";
import type { KpiMetric } from "@mahir/shared";
import { CatalogPackageBar } from "../../components/kpi/CatalogPackageBar";
import type { CatalogTableProps } from "../../components/kpi/CatalogTable";
import { activePackageNames, packageFilterVisible } from "../../lib/kpi-catalog-packages";
import { KPI_PACKAGES_COPY } from "../../lib/kpi-packages-copy";
import { useKpiPackagesStore } from "../../stores/kpi-packages-store";

export interface UseCatalogPackagesArgs {
  metrics: KpiMetric[] | null;
}

export function useCatalogPackages(args: UseCatalogPackagesArgs): {
  bar: JSX.Element | null;
  tableProps: Pick<CatalogTableProps, "packages">;
} {
  const { metrics } = args;
  const packages = useKpiPackagesStore((s) => s.packages);
  const membership = useKpiPackagesStore((s) => s.packageMembership);
  const loadPackages = useKpiPackagesStore((s) => s.loadPackages);
  const [filterIds, setFilterIds] = useState<string[]>([]);

  useEffect(() => {
    void loadPackages();
  }, [loadPackages]);

  const names = useMemo(() => activePackageNames(packages), [packages]);
  const options = useMemo(
    () =>
      packages
        .filter((p) => p.status === "active")
        .map((p) => ({
          value: p.id,
          label: p.name,
          hint: KPI_PACKAGES_COPY.page.itemCount(p.itemCount),
        })),
    [packages],
  );
  // arşivlenen / silinen paket süzgeçte kalmasın
  const activeFilter = useMemo(() => filterIds.filter((id) => names.has(id)), [filterIds, names]);
  const visibleIds = useMemo(
    () => packageFilterVisible(metrics ?? [], membership, activeFilter),
    [metrics, membership, activeFilter],
  );

  if (names.size === 0) return { bar: null, tableProps: {} };

  const bar = (
    <CatalogPackageBar
      options={options}
      filterIds={activeFilter}
      onFilterChange={setFilterIds}
      counts={visibleIds ? { visible: visibleIds.size, total: (metrics ?? []).length } : null}
    />
  );
  return {
    bar,
    tableProps: {
      packages: { membership, namesById: names, filterIds: activeFilter, visibleIds },
    },
  };
}
